import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BrandLogo } from "@/components/BrandLogo";
import { useAuth } from "@/contexts/AuthContext";
import { dashboardPathForUser } from "@/lib/roleRoutes";

export default function Login() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate(dashboardPathForUser(user), { replace: true });
    }
  }, [user, navigate]);

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (user === undefined || user) {
    return (
      <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center px-6" data-testid="login-loading-state">
        <p className="text-slate-400 text-sm">Loading CareerStudy360…</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center px-6" data-testid="login-page">
      <div className="w-full max-w-md rounded-2xl border border-slate-800/60 bg-slate-900/60 backdrop-blur-xl p-10 text-center shadow-2xl">
        <div className="mx-auto mb-6">
          <BrandLogo className="h-14 mx-auto" />
        </div>
        <h1 className="font-heading text-2xl font-bold text-white mb-2">Welcome to CareerStudy360</h1>
        <p className="text-sm text-slate-400 mb-8">
          Sign in securely with Google to continue your career journey.
        </p>
        <Button
          data-testid="google-login-button"
          onClick={handleGoogleLogin}
          className="w-full h-11 bg-white text-slate-900 hover:bg-slate-100 rounded-xl font-medium"
        >
          Continue with Google
        </Button>
        <p className="text-xs text-slate-500 mt-6">
          By continuing you agree to our research-grounded assessment approach and privacy practices.
        </p>
      </div>
    </div>
  );
}
